// extracted by mini-css-extract-plugin
module.exports = {"name":"SecondaryTitle-module__name--2z4lw","title":"SecondaryTitle-module__title--2HER2"};